module.exports = __webpack_public_path__ + "img/rheinwerk.6ced2037.png";